import { render, staticRenderFns } from "./TgBlockedBtn.vue?vue&type=template&id=962202c2"
import script from "./TgBlockedBtn.vue?vue&type=script&lang=js"
export * from "./TgBlockedBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports